export const receiptOfDriversRights = (name?: string, date?: string) => {
  return [
    { text: 'Receipt of Driver’s Rights', style: 'h1' },
    { text: 'Have each driver-applicant sign this form before you accept his/her employment application'},
    {
      canvas: [
        {
          type: 'line',
          x1: 0,
          y1: 20,
          x2: 500,
          y2: 20,
          lineWidth: 1,
          lineColor: 'black',
        },
      ]
    },
    { text: 'DRIVER REVIEW AND RECEIPT', margin: [0, 10, 0, 10], color: '#058ff4', bold: true, alignment: 'center', fontSize: 14 },
    {
      canvas: [
        {
          type: 'line',
          x1: 0,
          y1: 0,
          x2: 500,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
      ]
    },
    { text: 'I acknowledge that Sierra Expediting inc has provided me with written instruction regarding my rights as defined in 391.23(i)-(j) of the FMCSR. I have reviewed these materials which' +
        ' include information on the following:', style: 'p', margin: [0, 20, 0, 10]},
    {
      ul: [
        'Right to Review Information - I have the right to review the information provided by my previous DOT-regulated employers',
        'Right to Request Corrections - I have the right to request corrections to information that my previous DOT-regulated employers provides, which I believe contains errors.',
        'Right to Rebut Information - I have the right to rebut information provided by my previous DOT-regulated employers',
      ], style: 'ul', fontSize: 11,
    },
    { text: 'This issue of the FMCSR Pocketbook includes all revisions issued on or before April 12, 2008', style: 'p', margin: [0, 10, 0, 0]},
    { text: 'I acknowledge receipt of this Federal Motor Carrier Safety regulations Pocketbook (7-ORS-A). In addition, I agree to familiarize myself with the FMCSR of the USDOT, Parts 40, 380,' +
        ' 382, 383, 387, 390-397, 399 Subchapter B, Chapter 3, Title 49 of the Code of Federal Regulations, as contained therein.', style: 'p', margin: [0, 0, 0, 20] },
    { canvas: [
        {
          type: 'line',
          x1: 0,
          y1: 0,
          x2: 150,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
        {
          type: 'line',
          x1: 170,
          y1: 0,
          x2: 320,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
        {
          type: 'line',
          x1: 340,
          y1: 0,
          x2: 490,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
      ],
      style: 'input',
    },

    { text: `${name}`, margin: [0,-22, 0, 0]},
    { text: "Driver's Name", style: 'label', margin: [0,5,0,0]},
    { text: "Driver's Signature", style: 'label', margin: [170,-12,0,0]},
    { text: `${date}`, margin: [340,-32, 0, 0]},
    { text: "Date", style: 'label', margin: [340,5,0,0] },

    { text: '', pageBreak: 'before' },
  ];
};